<template>
  <div class="flex-row gap-md">
    <div class="flex-row gap-sm">
      <dd-filter-pill v-if="!packagesFilter.Lopend"
                      @click="onPackageInput('Lopend', true)">
        Geen: Lopende pakketten
      </dd-filter-pill>
      <dd-filter-pill v-if="!packagesFilter.Vervallen"
                      @click="onPackageInput('Vervallen', true)">
        Geen: Vervallen pakketten
      </dd-filter-pill>

      <dd-filter-pill v-if="!policiesFilter.Lopend"
                      @click="onPolicyInput('Lopend', true)">
        Geen: Lopende polissen
      </dd-filter-pill>
      <dd-filter-pill v-if="!policiesFilter.Vervallen"
                      @click="onPolicyInput('Vervallen', true)">
        Geen: Vervallen polissen
      </dd-filter-pill>
    </div>

    <a-dropdown placement="bottomRight" :trigger="['click']">
      <dd-filter-button :filter-count="activeFilterCount" data-dusk="filter-toggle"></dd-filter-button>
      <template #overlay>
        <dd-card data-dusk="filter-overlay" class="flex-col shadow-xl gap-y-sm">
          <div data-dusk="single-policies-filters" class="flex-row gap-sm">
            <dd-switch :value="policiesFilter['Vervallen']"
                       @input="(value) => onPolicyInput('Vervallen', value)"
                       title="Vervallen"
                       data-dusk="expired"
            ></dd-switch>
            <dd-switch :value="policiesFilter['Lopend']"
                       @input="(value) => onPolicyInput('Lopend', value)"
                       title="Lopend"
                       data-dusk="active"
            ></dd-switch>
          </div>
        </dd-card>
      </template>
    </a-dropdown>
  </div>
</template>

<script>
import { mapActions, mapState , mapMutations, mapGetters } from 'vuex';
import _ from 'lodash';

export default {
  name: "FilterComponent",
  props: {
    customerId: {
      type: Number,
      required: false,
    }
  },
  watch: {
    filter() {
      this.saveDisplayState();
      this.refreshPolicies();
    }
  },
  computed: {
    ...mapState(`$_policy_page`, {
      filter: 'filter',
      filterOptions: 'filterOptions'
    }),
    ...mapGetters(`$_policy_page`, {
      packagesFilter: 'packagesFilter',
      policiesFilter: 'policiesFilter',
      activeFilterCount: 'activeFilterCount',
    })
  },
  methods: {
    ...mapActions(`$_policy_page`, {
      saveDisplayState: 'saveDisplayState',
      getPolicyPageForCustomer: 'getPolicyPageForCustomer',
    }),
    ...mapMutations(`$_policy_page`, {
      setFilterValue: 'SET_FILTER_VALUE',
      clearAllPackagesFilters: 'CLEAR_ALL_PACKAGES_FILTERS',
      clearAllPoliciesFilters: 'CLEAR_ALL_POLICIES_FILTERS',
    }),
    onPolicyInput(code, value) {
      this.setFilterValue({ code, value, type: 'policies'  });
    },
    onPackageInput(code, value) {
      this.setFilterValue({ value, code, type: 'packages' });
    },
    refreshPolicies: _.debounce(function() { this.getPolicyPageForCustomer(this.customerId) }, 400),
  },

};
</script>

<style lang="scss" scoped>
@import "~@/_default.scss";
.filter-card {
  width: 300px;
  height: 50vh;
  overflow-y: auto
}
</style>
